import React from 'react';
import { AlertTriangleIcon, ClockIcon, ChevronRightIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
interface AttentionItem {
  id: string;
  type: 'dispute' | 'refund' | 'settlement';
  title: string;
  description: string;
  dueDate?: string;
  amount?: string;
  urgent?: boolean;
  link: string;
}
export function AttentionNeededWidget() {
  const navigate = useNavigate();
  const attentionItems: AttentionItem[] = [{
    id: '1',
    type: 'dispute',
    title: 'Dispute requires response',
    description: 'Dispute #DP-2024-0001',
    dueDate: 'Due in 2 hours',
    amount: 'THB 100.01',
    urgent: true,
    link: '/disputes/1'
  }, {
    id: '2',
    type: 'dispute',
    title: 'Dispute requires response',
    description: 'Dispute #DP-2024-0091',
    dueDate: 'Due in 5 hours',
    amount: 'THB 1,538.94',
    urgent: true,
    link: '/disputes/91'
  }];
  const getTypeColor = (type: string) => {
    switch (type) {
      case 'dispute':
        return 'text-red-700 bg-red-50 border border-red-100';
      case 'refund':
        return 'text-orange-700 bg-orange-50 border border-orange-100';
      case 'settlement':
        return 'text-blue-700 bg-blue-50 border border-blue-100';
      default:
        return 'text-gray-700 bg-gray-50 border border-gray-100';
    }
  };
  const urgentCount = attentionItems.filter(item => item.urgent).length;
  return <div className="bg-white rounded-lg border border-gray-200 overflow-hidden flex flex-col h-full" data-id="element-2409">
      {/* Header */}
      <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between bg-white" data-id="element-2410">
        <h3 className="text-sm font-semibold text-gray-900 flex items-center" data-id="element-2411">
          <AlertTriangleIcon size={16} className="mr-2 text-orange-500" data-id="element-2412" />
          Attention needed
        </h3>
        {urgentCount > 0 && <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-50 text-red-700 border border-red-100" data-id="element-2413">
            {urgentCount} urgent
          </span>}
      </div>

      {/* Body */}
      <div className="bg-white flex-1 flex flex-col" data-id="element-2414">
        <div className="divide-y divide-gray-100 flex-1" data-id="element-2415">
          {attentionItems.map(item => <button key={item.id} onClick={() => navigate(item.link)} className="w-full text-left px-4 py-2 hover:bg-gray-50 transition-colors group flex items-center gap-2.5" data-id="element-2416">
              <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium uppercase tracking-wider flex-shrink-0 ${getTypeColor(item.type)}`} data-id="element-2417">
                {item.type}
              </span>
              {item.urgent && <span className="inline-flex items-center text-[10px] text-red-600 font-semibold flex-shrink-0" data-id="element-2418">
                  <ClockIcon size={10} className="mr-0.5" data-id="element-2419" />
                  Urgent
                </span>}
              <span className="text-sm font-medium text-gray-900 truncate" data-id="element-2420">
                {item.description}
              </span>
              <span className="text-xs text-gray-400 flex-shrink-0" data-id="element-2421">·</span>
              {item.dueDate && <span className="text-xs text-gray-500 flex-shrink-0 whitespace-nowrap" data-id="element-2422">
                  {item.dueDate}
                </span>}
              {item.amount && <>
                  <span className="text-xs text-gray-400 flex-shrink-0" data-id="element-2423">·</span>
                  <span className="text-xs font-medium text-gray-700 flex-shrink-0 whitespace-nowrap" data-id="element-2424">
                    {item.amount}
                  </span>
                </>}
              <ChevronRightIcon size={14} className="text-gray-400 group-hover:text-blue-600 transition-colors flex-shrink-0 ml-auto" data-id="element-2425" />
            </button>)}
        </div>
      </div>

      {/* Footer */}
      <div className="bg-[#FFF7ED] px-4 py-3 rounded-b-lg flex items-center justify-between h-12" data-id="element-2426">
        <div className="flex items-center gap-1.5 min-w-0" data-id="element-2427">
          <AlertTriangleIcon size={14} className="text-[#F7941D] flex-shrink-0" data-id="element-2428" />
          <span className="text-xs font-medium text-[#92400E] truncate" data-id="element-2429">
            {attentionItems.length} items require your attention
          </span>
        </div>
        <button onClick={() => navigate('/disputes')} className="text-xs text-[#F7941D] hover:text-[#D97B06] font-semibold flex items-center flex-shrink-0 ml-3" data-id="element-2430">
          View all items
          <ChevronRightIcon size={14} className="ml-1" data-id="element-2431" />
        </button>
      </div>
    </div>;
}